// extracted by mini-css-extract-plugin
module.exports = {"container_loader":"styles_container_loader__p7G_3"};